import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import DatePicker from 'react-datepicker'
import classNames from 'classnames'

import { ReactComponent as Calendar } from './icons/calendar.svg'
import { ReactComponent as Clock } from './icons/wall-clock.svg'
import { DATE_FORMAT } from 'config/consts'
import 'react-datepicker/dist/react-datepicker.css'
import style from './DateTimePicker.module.scss'
import sharedStyles from '../shared/styles/forms.module.scss'

class PickerInput extends Component {
	render({ id, picker, label, onClickIcon, ...rest } = this.props) {
		return (
			<Fragment>
				{label && <p
					className={classNames(sharedStyles.label, { [sharedStyles['highlighted-label']]: !rest.value })}>{label}</p>}
				<div className={style['input-wrapper']}>
					<input
						id={id}
						{...rest}
						type='text'
						autoComplete='off'/>
					{picker === 'time' ? <Clock className={style.icon} onClick={onClickIcon}/> :
						<Calendar className={style.icon} onClick={onClickIcon}/>}
				</div>
			</Fragment>
		)
	}
}


const PickerComponent = (props) => {
	const [t, i18n] = useTranslation()

	const { id, onChange, label } = props
	let { picker } = props
	const handleIconClick = e => {
		picker.setOpen(!picker.isCalendarOpen())
	}
	let pickerProps = {
		...props,
		id: id,
		dateFormat: DATE_FORMAT,
		customInput: <PickerInput picker={picker} label={label} onClickIcon={handleIconClick}/>
	}

	if (picker === 'time') {
		pickerProps = {
			...pickerProps,
			utcOffset: 0,
			showTimeSelect: true,
			showTimeSelectOnly: true,
			timeIntervals: 15,
			dateFormat: 'HH:mm',
			timeFormat: 'HH:mm',
			timeCaption: t('common.fields.time')
		}
	}
	let ll
	const currentLanguage = i18n.language
	switch (currentLanguage) {
		case 'English': {
			ll = 'en-gb' //gb - great britain
			break
		}
		case 'German': {
			ll = 'de'
			break
		}
		case 'French': {
			ll = 'fr'
			break
		}
		case 'Italian': {
			ll = 'it'
			break
		}
		default: {
			ll = 'de'
			break
		}
	}
	//moment items localization
	require(`moment/locale/${ll}`)
	moment.locale(ll)
	return (
		<DatePicker
			{...pickerProps}
			ref={ref => {
				picker = ref
			}}
			onChange={onChange}
		/>
	)
}

PickerComponent.propTypes = {
	id: PropTypes.string, // Required to focus input on click to the picker ico
	onChange: PropTypes.func.isRequired,
	interval: PropTypes.bool,
	label: PropTypes.string
}

PickerComponent.defaultProps = {}

export default PickerComponent
